import { WSService } from "../../../../utils/WSService";

export const insuranceImportService = new WSService("/v2/insurance/import");
